<template>
	<div class="c-app flex-row align-items-center">
		<CContainer>
			<CRow class="justify-content-center">
				<CCol md="12">
					<CCardGroup>
						<CCard
							color="primary"
							text-color="white"
							class="text-center d-md-down-none"
							body-wrapper
						>
							<CCardBody>
								<img
									:src="logo"
									style="width: 13rem; height: 3rem"
									class="mb-2"
								/>
								<img src="login1.png" style="width: 24rem; height: 14rem" />

								<h3>Your Prescription for Savings</h3>
							</CCardBody>
						</CCard>
						<CCard class="p-4">
							<CCardBody>
								<div class="p-4">
									<h2>Forgot Password</h2>
									<br />
									<CInput
										v-if="!enteredMail"
										placeholder="Email"
										prepend="@"
										:value.sync="$v.loginDetails.mail.$model"
										:isValid="checkValidLogin('mail')"
										invalidFeedback="Enter a valid email id"
										description="Enter the email to reset the password"
										class="email login-form-group"
										@keyup.enter="loginHandler"
									/>

									<p style="color: red; text-align: center">
										{{ errorText }}
									</p>

									<br />

									<div class="inactive-modal-response">
										<CButton
											color="secondary"
											@click="$router.push('login')"
											class="px-4 mr-2"
											>Cancel
										</CButton>
										<CButton
											v-if="!enteredMail"
											color="primary"
											@click="loginHandler"
											class="px-4"
											>Reset
										</CButton>
									</div>
								</div>
							</CCardBody>
						</CCard>
					</CCardGroup>
				</CCol>
			</CRow>
			<CModal
				title="Reset Successful"
				centered
				fade
				:show.sync="resetResponseModal"
				class="addCategoryModal"
				:closeOnBackdrop="false"
			>
				<p>{{ responseMessage }}</p>
				<br />
				<CButton
					type="submit"
					color="primary"
					class="m-1"
					@click="$router.push(`/login`)"
					:style="{ float: 'right' }"
					@keyup.enter="$router.push(`/login`)"
					>Ok</CButton
				>
			</CModal>

			<CElementCover v-if="spinner" :opacity="0.8" />
		</CContainer>
	</div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import queries from "./queries";
import { storeData } from "../../store";
import logo from "../../assets/images/logo.svg";
import api from "../../api/reset";

export default {
	name: "Login",
	data() {
		return {
			logo,
			loginDetails: {
				mail: "",
				password: null,
			},
			enteredMail: "",
			errorText: "",
			role: "",
			receivedOtp: "",
			enteredOtp: "",
			verified: false,
			conformPassword: "",
			userType: "",
			resetResponseModal: false,
			responseMessage: "",
			spinner: false,
		};
	},
	mixins: [validationMixin],
	validations: {
		loginDetails: {
			mail: { required, email },
			password: { required },
		},
	},

	methods: {
		checkValidLogin(fieldName) {
			const field = this.$v.loginDetails[fieldName];
			if (!field.$dirty) {
				return null;
			}
			return !(field.$invalid || field.$model === "");
		},

		checkValidConfirmPassword() {
			if (
				this.loginDetails.password == null ||
				this.loginDetails.password.length < 8
			)
				return null;
			if (
				this.loginDetails.password == this.conformPassword &&
				this.conformPassword.length >= 8
			) {
				return true;
			}
			return false;
		},

		validate() {
			this.$v.$touch();
		},
		reset() {
			this.loginDetails = {
				mail: "",
				password: null,
			};
		},
		async loginHandler() {
			this.spinner = true;
			this.validate();
			if (this.$v.loginDetails.mail.$invalid) {
				return;
			}
			try {
				const res = await api.forgotPassword({
					email: this.loginDetails.mail,
				});

				console.log(res);

				if (res.data.statusCode === 200) {
					this.resetResponseModal = true;
					this.responseMessage =
						"Reset link has been sent to your mail. Follow the link to reset your password.";
				} else {
					this.resetResponseModal = true;
					this.responseMessage = res.data.message;
				}
				this.spinner = false;
			} catch (err) {
				console.log(err);
				this.resetResponseModal = true;
				this.responseMessage = "Something went wrong. Please try again.";
				this.spinner = false;
			}
		},

		resendOTP() {
			this.errorText = "OTP Resent.";
			this.sendOTP();
		},

		sendOTP() {
			console.log("otp sent");
			this.axios
				.post(
					"https://jj4amxe6e6.execute-api.us-east-2.amazonaws.com/Dev/email-otp",
					{
						mail: this.enteredMail,
					}
				)
				.then((res) => {
					this.receivedOtp = res?.data?.otp;
				})
				.catch((err) => {
					console.log(err);
				});
		},

		verifyOtp() {
			if (this.enteredOtp == this.receivedOtp) {
				this.verified = true;
				this.errorText = "";
			} else {
				this.errorText = "OTP Invalid!!";
			}
		},

		async resetPassword() {
			this.isLoading = true;
			let { email, password } = this.loginDetails;
			const res = await axios.post(process.env.VUE_APP_STORE_PASSWORD, {
				id: storeData.currentUserDetails.id,
				email,
				password,
			});

			const result = JSON.parse(res.data.body);
			this.isLoading = false;
			if (result.statusCode === 200) {
				this.$router.push("/login");
			} else {
				this.error = result.message;
			}
		},
	},
};
</script>

<style scoped>
.login-form-group {
	margin-bottom: 1rem !important;
}
</style>
